import * as React from 'react';
import { PhotoIcon } from '@heroicons/react/24/outline';
import { ComponentProps, type JSX } from 'react';
import { cn } from '@restworld/utils-common';
export function ImagePlaceholder({ wrapperStyle, iconClasses = '', Icon, className }: ImagePlaceholderProps) {
  const currentIconClasses = iconClasses || 'h-6 w-6 fill-purple-700';
  const ImageIcon = Icon || PhotoIcon;
  return (
    <Wrapper twStyle={wrapperStyle} className={className}>
      <ImageIcon className={currentIconClasses} />
    </Wrapper>
  );
}
export default ImagePlaceholder;

interface ImagePlaceholderProps {
  wrapperStyle?: string;
  iconClasses?: string;
  className?: string;
  Icon?: (props: ComponentProps<'svg'>) => JSX.Element;
}

const Wrapper = ({ twStyle, className, ...props }: any) => (
  <div
    className={cn('w-16 h-16 bg-purple-50 grid place-items-center rounded-lg overflow-hidden', twStyle, className)}
    {...props}
  />
);
